export default {"src":"/_next/static/media/storage.505237a5.svg","height":58,"width":84};